export const creativeConstants = {
    creative_cta: "Without CTAs",
    creative_size: ["vertical", "horizontal", "react"],
    messaging_sparks: ["Drug", "Copay", "Rep", "Sample", "Trial"],
    workflowWithAdds: [
        "Login",
        "Calendar/Waiting Room",
        "Patient chart",
        "Consultation",
        "Procedure",
        "Prescription",
        "Diagnosis",
    ],
};

export const NEW_AD_CREATIVE = {
  CARE_DURA: "care_dura",
  CARE_DURA_NO_CTA: "care_dura_no_cta",
  PAINFIN: "painfin",
  PAINFIN_NO_CTA: "painfin_no_cta",
  SCLERODERMA: "scleroderma",
  SCLERODERMA_NO_CTA: "scleroderma_no_cta",
  PSORIASIS_TRAIL: "psoriasis_trail",
  PSORIASIS_TRAIL_NO_CTA: "psoriasis_trail_no_cta",
};

// export const NEW_CREATIVE_LOCATION = {
//     [NEW_AD_CREATIVE.CARE_DURA]: {
//         horizontal: "caredura/horizontal.png",
//         vertical: "caredura/vertical.png",
//         square: "caredura/square.png",
//     },
//     [NEW_AD_CREATIVE.PAINFIN]: {
//         horizontal: "painfin/horizontal.png",
//         vertical: "painfin/vertical.png",
//         square: "painfin/square.png",
//     },
//     [NEW_AD_CREATIVE.SCLERODERMA]: {
//         horizontal: "scleroderma/horizontal.png",
//         vertical: "scleroderma/vertical.png",
//         square: "scleroderma/square.png",
//     },
//     [NEW_AD_CREATIVE.PSORIASIS_TRAIL]: {
//         horizontal: "psoriasis-trail/horizontal.png",
//         vertical: "psoriasis-trail/vertical.png",
//         square: "psoriasis-trail/square.png",
//     },
// }

export const NEW_CREATIVE_LOCATION = {
  [NEW_AD_CREATIVE.CARE_DURA]: {
    horizontal: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-728x90.png"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-728x90.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    vertical: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-300x600.png"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-300x600.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    square: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-300x250.png"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-300x250.png" alt="Ad Image" />
    </div>
</body>
</html>`,
  },
  [NEW_AD_CREATIVE.CARE_DURA_NO_CTA]: {
    horizontal: `<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-nbtn-728x90.png"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-nbtn-728x90.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    vertical: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-nbtn-300x600.png"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-nbtn-300x600.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    square: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-nbtn-300x250.png"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-nbtn-300x250.png" alt="Ad Image" />
    </div>
</body>
</html>`,
  },
  [NEW_AD_CREATIVE.PAINFIN_NO_CTA]: {
    horizontal: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/painfin/ortho-728x90.png"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/painfin/ortho-728x90.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    vertical: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/painfin/ortho-300x600.png"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/painfin/ortho-300x600.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    square: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/painfin/ortho-300x250.png"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/painfin/ortho-300x250.png" alt="Ad Image" />
    </div>
</body>
</html>`,
  },
  [NEW_AD_CREATIVE.PAINFIN]: {
    horizontal: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/painfin/painfin-n-728x90.png"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
 <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/painfin/painfin-n-728x90.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    vertical: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/painfin/painfin-n-300x600.png"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/painfin/painfin-n-300x600.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    square: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/painfin/painfin-n-300x250.png"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/painfin/painfin-n-300x250.png" alt="Ad Image" />
    </div>
</body>
</html>`,
  },
  [NEW_AD_CREATIVE.SCLERODERMA]: {
    horizontal: `<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/scheloderma/scheloderma-728x90.png"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/scheloderma/scheloderma-728x90.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    vertical: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/scheloderma/scheloderma-300x600.png"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/scheloderma/scheloderma-300x600.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    square: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/scheloderma/scheloderma-300x250.png"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/scheloderma/scheloderma-300x250.png" alt="Ad Image" />
    </div>
</body>
</html>`,
  },
  [NEW_AD_CREATIVE.SCLERODERMA_NO_CTA]: {
    horizontal: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/scheloderma/scheloderma-nbtn-728x90.png"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/scheloderma/scheloderma-nbtn-728x90.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    vertical: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/scheloderma/scheloderma-nbtn-300x600.png"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/scheloderma/scheloderma-nbtn-300x600.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    square: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/scheloderma/scheloderma-nbtn-300x250.png"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/scheloderma/scheloderma-nbtn-300x250.png" alt="Ad Image" />
    </div>
</body>
</html>`,
  },
  [NEW_AD_CREATIVE.PSORIASIS_TRAIL]: {
    horizontal: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-728x90-cta.png"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-728x90-cta.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    vertical: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-300x600-cta.png"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-300x600-cta.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    square: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-300x250-cta.png"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-300x250-cta.png" alt="Ad Image" />
    </div>
</body>
</html>`,
  },
  [NEW_AD_CREATIVE.PSORIASIS_TRAIL_NO_CTA]: {
    horizontal: `<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-nbtn-728x90.png"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-nbtn-728x90.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    vertical: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-nbtn-300x600.png"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-nbtn-300x600.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    square: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-nbtn-300x250.png"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
    <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/caredura/caredura-nbtn-300x250.png" alt="Ad Image" />
    </div>
</body>
</html>`,
  },
};

export const htmls = {
    MedizenHoriAddWithCta: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Medizen</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-728x90-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-728x90-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    MedizenVertAddWithCta: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Medizen</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x600-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x600-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    MedizenRectAddWithCta: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Medizen</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PanazReactAddWithCta: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Panaz</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PanazVertAddWithCta: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Panaz</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x600-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x600-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PanazHoriAddWithCta: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Panaz</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-n-728x90-CTA.png"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-n-728x90-CTA.png" alt="Ad Image" />
    </div>
</body>
</html>`,

    PrimeraReactAddWithCTA: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PrimeraVertAddWithCTA: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x600-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x600-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PrimeraHoriAddWithCTA: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-728x90-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-728x90-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,

    MedizenReactAddWithoutCTA: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Medizen</title>
    <style>
        body {
        margin: 0;
        padding: 0;
        }
        #renderPreview {
        position: relative;
        display: inline-block;
        width: 100%;
        height: 100%;
        }
        img {
        max-width: 100%;
        height: auto;
        }
        html, body{
        height:100%;
        }
    </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    MedizenVertAddWithoutCTA: `<html lang="en">

<head>
    <title>300X600</title>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style>
        body {
        margin: 0;
        padding: 0;
        }
        #renderPreview {
        position: relative;
        display: inline-block;
        width: 100%;
        height: 100%;
        }
        img {
        max-width: 100%;
        height: auto;
        }
        html, body{
        height:100%;
        }
    </style>

</head>

<body>
    <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x600-CTA.jpg" alt=""/>
    </div>
</body>
</html>`,
    MedizenHoriAddWithoutCTA: `<html lang="en">

<head>
    <title>728X90</title>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style>
        body {
        margin: 0;
        padding: 0;
        }
        #renderPreview {
        position: relative;
        display: inline-block;
        width: 100%;
        height: 100%;
        }
        img {
        max-width: 100%;
        height: auto;
        }
        html, body{
        height:100%;
        }
    </style>

</head>

<body>
<div id="renderPreview">
    <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-728x90-CTA.jpg" alt=""/>
    </div>
</body>
</html>`,

    PanazReactAddWithoutCTA: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Panaz</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PanazVertAddWithoutCTA: `<html lang="en">

<head>
    <title>300X600</title>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style>
        body {
        margin: 0;
        padding: 0;
        }
        #renderPreview {
        position: relative;
        display: inline-block;
        width: 100%;
        height: 100%;
        }
        img {
        max-width: 100%;
        height: auto;
        }
        html, body{
        height:100%;
        }
    </style>

</head>

<body>
<div id="renderPreview">
    <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x600-CTA.jpg" alt=""/>
    </div>
</body>
</html>`,
    PanazHoriAddWithoutCTA: `<html lang="en">

<head>
    <title>728X90</title>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style>
        body {
        margin: 0;
        padding: 0;
        }
        #renderPreview {
        position: relative;
        display: inline-block;
        width: 100%;
        height: 100%;
        }
        img {
        max-width: 100%;
        height: auto;
        }
        html, body{
        height:100%;
        }
    </style>

</head>

<body>
<div id="renderPreview">
    <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-n-728x90-CTA.png" alt=""/>
    </div>
</body>
</html>`,

    PrimeraReactAddWithoutCTA: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: false,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PrimeraVertAddWithoutCTA: `<html lang="en">

<head>
    <title>300X600</title>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style>
        body {
        margin: 0;
        padding: 0;
        }
        #renderPreview {
        position: relative;
        display: inline-block;
        width: 100%;
        height: 100%;
        }
        img {
        max-width: 100%;
        height: auto;
        }
        html, body{
        height:100%;
        }
    </style>

</head>

<body>
 <div id="renderPreview">
    <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x600-CTA.jpg" alt=""/>
    </div>
</body>
</html>`,
    PrimeraHoriAddWithoutCTA: `<html lang="en">

<head>
    <title>728X90</title>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <style>
        body {
        margin: 0;
        padding: 0;
        }
        #renderPreview {
        position: relative;
        display: inline-block;
        width: 100%;
        height: 100%;
        }
        img {
        max-width: 100%;
        height: auto;
        }
        html, body{
        height:100%;
        }
    </style>

</head>

<body>
<div id="renderPreview">
    <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-728x90-CTA.jpg" alt=""/>
    </div>
</body>
</html>`,

    MedizenReactAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Medizen</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    MedizenVertAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Medizen</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x600-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x600-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    MedizenHoriAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Medizen</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-728x90-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-728x90-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    MedizenReactAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Medizen</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    MedizenVertAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Medizen</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x600.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x600.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    MedizenHoriAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Medizen</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-728x90.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-728x90.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,

    MedizenReactAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Medizen</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    MedizenVertAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Medizen</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x600-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x600-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    MedizenHoriAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Medizen</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-728x90-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-728x90-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    MedizenReactAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Medizen</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x250.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    MedizenVertAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Medizen</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x600.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-300x600.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    MedizenHoriAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Medizen</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-728x90.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Medizen-728x90.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,

    PanazReactAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Panaz</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PanazVertAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Panaz</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x600-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x600-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PanazHoriAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Panaz</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-n-728x90-CTA.png"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-n-728x90-CTA.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    PanazReactAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Panaz</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PanazVertAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Panaz</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x600.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x600.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PanazHoriAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Panaz</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-728x90.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-728x90.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,

    PanazReactAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Panaz</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PanazVertAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Panaz</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-n-300x600-CTA.png"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-n-300x600-CTA.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    PanazHoriAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Panaz</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-n-728x90-CTA.png"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-n-728x90-CTA.png" alt="Ad Image" />
    </div>
</body>
</html>`,
    PanazReactAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Panaz</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x250.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PanazVertAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Panaz</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x600.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-300x600.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PanazHoriAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Panaz</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-728x90.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Panaz-728x90.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,

    PrimeraReactAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Primera</title>
     <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PrimeraVertAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Primera</title>
     <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x600-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x600-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PrimeraHoriAddWithCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call CTA - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-728x90-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-728x90-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PrimeraReactAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PrimeraVertAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x600.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x600.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PrimeraHoriAddWithoutCTARep: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request call - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-728x90.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_call"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-728x90.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,

    PrimeraReactAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PrimeraVertAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x600-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x600-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PrimeraHoriAddWithCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample CTA - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-728x90-CTA.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-728x90-CTA.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PrimeraReactAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":250,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x250.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PrimeraVertAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x600.jpg"
        var htmlText = ""
        var data = {
            "width":300,
            "height":600,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-300x600.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
    PrimeraHoriAddWithoutCTASample: `<html>
<head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <title>Request sample - Primera</title>
    <style>
    body {
      margin: 0;
      padding: 0;
    }
    #renderPreview {
      position: relative;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
    img {
      max-width: 100%;
      height: auto;
    }
      html, body{
      height:100%;
      }
  </style>
    <script>
        var imgLnk = "https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-728x90.jpg"
        var htmlText = ""
        var data = {
            "width":728,
            "height":90,
            isDisplayAd: true,
            type:"banner",
            displayPlusType: "request_sample"
        }
    </script>
    <style>
        #previewAdIframe {border: 0px solid #ccc; box-sizing: border-box; display:none} body {margin:0px !important}
    </style>
    <script type="text/javascript" src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/ads-render.js"></script>
</head>
<body>
     <div id="renderPreview">
            <img src="https://servedbydoceree.doceree.com/html/partner-toolbox/display-plus/Primera-728x90.jpg" alt="Ad Image" />
    </div>
</body>
</html>`,
};
